import React, { useState } from 'react';
import moment from 'moment';

import './Styles.css';
import { FormControl } from '../../../../facturotopia';
import CalendarDatePicker from '../../../../facturotopia/calendar-date-picker/CalendarDatePicker';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

const CustomDatePicker = (props) => {
  const [date, setDate] = useState(new Date());

  const [range, setRange] = useState('year');

  const getFromAndTo = (date, theRange) => {
    let from = '';
    let to = '';

    if (theRange === 'decade') {
      from = moment(date).startOf('year').format('YYYY-MM-DD');
      to = moment(date).endOf('year').format('YYYY-MM-DD');
    } else if (theRange === 'year') {
      from = moment(date).startOf('month').format('YYYY-MM-DD');
      to = moment(date).endOf('month').format('YYYY-MM-DD');
    } else {
      from = moment(date[0]).format('YYYY-MM-DD');
      to = moment(date[1]).format('YYYY-MM-DD');
    }

    return { from, to };
  };

  const handleOnDateChange = (date) => {
    const { from, to } = getFromAndTo(date, range);

    setDate(date);

    props.onDateChange({ from, to });
  };

  const handleOnRangeChange = (value) => {
    let date = new Date();

    if (value.range === 'month') {
      date = [moment().subtract(15, 'days').toDate(), new Date()];
    }

    setRange(value.range);

    setDate(date);
  };

  return (
    <div className="d-flex flex-column flex-sm-row">
      <FormControl
        type="select"
        label=""
        name="range"
        placeholder=""
        help=""
        value={range}
        options={options}
        onChange={handleOnRangeChange}
      />
      <div className="pb-3">
        {range === 'decade' && (
          <CalendarDatePicker
            name="fecha"
            format={range === 'year' ? 'MM/yyyyy' : 'yyyyy'}
            value={date}
            minDetail={range}
            maxDetail={range}
            onDateChange={handleOnDateChange}
          />
        )}

        {range === 'year' && (
          <CalendarDatePicker
            name="fecha"
            format={range === 'year' ? 'MM/yyyyy' : 'yyyyy'}
            value={date}
            minDetail={range}
            maxDetail={range}
            onDateChange={handleOnDateChange}
          />
        )}

        {range === 'month' && (
          <CalendarDateRangePicker
            name="fecha"
            value={date}
            onDateChange={handleOnDateChange}
          />
        )}
      </div>
    </div>
  );
};

const options = [
  {
    label: 'Año',
    value: 'decade',
  },
  {
    label: 'Mes',
    value: 'year',
  },
  {
    label: 'Día',
    value: 'month',
  },
];

export default CustomDatePicker;
